import React from 'react'
import { extendTailwindMerge } from 'tailwind-merge'

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

type AvatarProps = React.ComponentPropsWithoutRef<'div'> & {
    backgroundColor?: string
    foregroundColor?: string
    size?: AvatarSize
}

const sizeClasses: Record<AvatarSize, string> = {
    xs: 'size-6 text-label-xs',
    sm: 'size-9 text-label-md',
    md: 'size-12 text-heading-xs',
    lg: 'size-16 text-heading-md',
    xl: 'size-20 text-heading-lg',
    xxl: 'size-29 text-display-md',
}

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                'text-label-xs',
                'text-label-md',
                'text-heading-xs',
                'text-heading-md',
                'text-heading-lg',
                'text-display-md',
            ],
        },
    },
})

const Avatar = ({
    backgroundColor = 'bg-gray-200',
    foregroundColor = 'text-gray-700',
    size = 'md',
    children,
    className,
    ...props
}: AvatarProps) => {
    return (
        <div
            className={twMerge(
                'flex items-center justify-center rounded-full font-bold',
                backgroundColor,
                foregroundColor,
                sizeClasses[size],
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

export default Avatar
